// src/App.js
import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AuthContext from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Customers from './pages/Customers';
import Settings from './pages/Settings';
import Queries from './pages/Queries';
import Reviews from './pages/Reviews';
import Seo from './pages/Seo';
import Sidebar from './components/Sidebar';
import PrivateRoute from './components/PrivateRoute';
import LoadingSpinner from './components/LoadingSpinner';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';

// Admin-only routes redirect SEO staff to their SEO workspace.
const AdminRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'seo') return <Navigate to="/seo" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

const AppContent = () => {
  const location = useLocation();
  const noSidebarPaths = ['/login', '/signup', '/forgot-password'];
  const showSidebar = !noSidebarPaths.includes(location.pathname);

  return (
    <div className="min-h-screen bg-background">
      {showSidebar && <Sidebar />}
      <main className={`min-h-screen transition-all duration-300 ${showSidebar ? 'ml-64' : ''}`}>
        <div className="p-6 lg:p-8">
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
            <Route path="/products" element={<AdminRoute><Products /></AdminRoute>} />
            <Route path="/orders" element={<AdminRoute><Orders /></AdminRoute>} />
            <Route path="/customers" element={<AdminRoute><Customers /></AdminRoute>} />
            <Route path="/queries" element={<AdminRoute><Queries /></AdminRoute>} />
            <Route path="/reviews" element={<AdminRoute><Reviews /></AdminRoute>} />
            <Route path="/settings" element={<AdminRoute><Settings /></AdminRoute>} />
            {/* SEO workspace — accessible to both admins and SEO staff */}
            <Route path="/seo" element={<PrivateRoute><Seo /></PrivateRoute>} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default App;
